import { useQuery } from '@tanstack/react-query';
import { useOrgStore } from '@/stores/org-store';
import { listOrgSchedules } from '@/services/schedules/list-org-schedules';
import type { OrgSchedule } from '@/types/schedules';

export const orgSchedulesQueryKey = (orgId?: string) => [
  'org-schedules',
  orgId,
];

export const useListOrgSchedules = () => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useQuery<OrgSchedule[], Error>({
    queryKey: orgSchedulesQueryKey(orgId),
    queryFn: () => listOrgSchedules(orgId!),
    enabled: !!orgId,
    staleTime: 30_000,
    retry: 1,
  });
};
